import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { AmpersandAndText } from 'www-cms';
import { BaseBuildingBlockComponent } from '../components/base-building-block.component';
import { LastItemBgClass } from '../../shell/shell.service';
import { DirectusDirective } from 'directus';

@Component({
  selector: 'ss-www-ampersand-and-text',
  imports: [DirectusDirective],
  templateUrl: './ampersand-and-text.component.html',
  styles: [``],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AmpersandAndTextComponent extends BaseBuildingBlockComponent {
  @Input({ required: true }) ampersandAndTextData!: AmpersandAndText;

  override getBgClass(): LastItemBgClass {
    return 'bg-ss-www-background';
  }
}
